import { css } from 'styled-components';
import { SizesValues } from '../type';

const Sizes = {
  M: { fontSize: 3, textShadow: 0.4, stroke: 0.03 },
  L: { fontSize: 4.5, textShadow: 0.6, stroke: 0.045 },
  XL: { fontSize: 6, textShadow: 0.8, stroke: 0.06 },
};

export const TextCSS = ({ size = 'M' }: { size?: SizesValues }) => css`
  font-size: ${(props) =>
    `${Sizes[size].fontSize.toString()}${props.theme.unit}`};
  text-shadow: 0
    ${(props) => `${Sizes[size].textShadow.toString()}${props.theme.unit}`} 0
    #000;
  -webkit-text-stroke: ${(props) =>
      `${Sizes[size].stroke.toString()}${props.theme.unit}`}
    #000;
`;
